<template>
  <div class="pythonData">
    <template v-if="from!='introDetail'">
    <Header />
    <Box1 />
    </template>
    <!-- <Box2 /> -->
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6 />
    <Box7 />
    <!-- <Box8 /> -->
    <Box9 />
    <Box10 />
    <Box11 />
    <Box12 />
    <Box13 />
    <Box14 />
    <Box15 />
    <Box16 />
    <Box17 />
    <Box18 />
    <Box19 />
    <Box20 />
    <Footer />
    <pageRightFloat pageName="Python+大数据" />
  </div>
</template>

<script>
import Box1 from "./Box1.vue";
import Box2 from "./Box2.vue";
import Box3 from "./Box3.vue";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
import Box6 from "./Box6.vue";
import Box7 from "./Box7.vue";
import Box8 from "./Box8.vue";
import Box9 from "./Box9.vue";
import Box10 from "./Box10.vue";
import Box11 from "./Box11.vue";
import Box12 from "./Box12.vue";
import Box13 from "./Box13.vue";
import Box14 from "./Box14.vue";
import Box15 from "./Box15.vue";
import Box16 from "./Box16.vue";
import Box17 from "./Box17.vue";
import Box18 from "./Box18.vue";
import Box19 from "./Box19.vue";
import Box20 from "./Box20.vue";

import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
export default {
  components: {
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box7,
    Box8,
    Box9,
    Box10,
    Box11,
    Box12,
    Box13,
    Box14,
    Box15,
    Box16,
    Box17,
    Box18,
    Box19,
    Box20,
    Header,
    Footer,
    pageRightFloat,
  },
  data() {
    return {
      from:''
    };
  },
  mounted() {
   this.from=this.getQueryString("from")
  },
};
</script>

<style lang="less" scoped>
/deep/.course-title-box {
  .course-title {
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #002233;
    line-height: 56px;
  }
  .course-text {
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #0080ff;
    line-height: 48px;
    margin-top: 48px;
  }
}
</style>
